<template>
	<div class="device-page">
		<el-header>
            <div class="left-buttons">
			    <el-button icon="el-icon-caret-left" size="small" @click="navigate"></el-button>
			    <el-button icon="el-icon-refresh" size="small" @click="refreshData" title="refresh page"></el-button>
            </div>
            <div class="right-buttons">
                <el-button class="action-button cache-store" size="small" @click="cacheStore" title="force cache store">Cache store</el-button>
                <el-button class="action-button force-update" size="small" @click="forceUpdate" title="force update">Force update</el-button>
                <el-button class="action-button reboot" size="small" @click="reboot" title="reboot device">Reboot</el-button>
                <el-button class="action-button restart" size="small" @click="restart" title="restart app">Restart</el-button>
                <el-button class="action-button delete" size="small" @click="deleteDevice1" title="delete device" :disabled="!isBox">Delete</el-button>
                <el-button class="action-button purge" size="small" @click="purge" title="purge device" :disabled="!isBox">Purge</el-button>
            </div>
		</el-header>
		<el-main>
            <el-alert v-if="device_information.migratable === false"
                title="This devices is not migratable"
                type="error"
                :closable="false"
                :center="true"
                effect="dark">
            </el-alert>
            <div class="main-row">
                <div class="device-info panel">
                    <div class="header">
                        <h2 class="title">{{ device_information.device_name }}  <el-tag v-if="device_information.device_name != 'Bridge'" :type="device_information.isPurchased?'success':'warning'" size="small">{{device_information.isPurchased?'PURCHASED':'DIY'}}</el-tag></h2>
                    </div>
                    <div class="info-display">
                        <el-tabs style="width:100%; height: 100%" type="card" class="info-tabs" @tab-click="handleClick">
                          <el-tab-pane label="Summary">
                            <div class="info-display" style="max-height:400px">
                              <div class="status block">
                                <span class="title">STATUS</span>
                                  <div class="content">
                                      <i v-if="device_information.status === 'Online'" class="el-icon-success" style="color:#00b825;font-size:16px;"/>
                                      <i v-else class="el-icon-error" style="color:#e61717;font-size:16px;"/>
                                      Device {{ device_information.status ? device_information.status : 'Offline' }}
                                  </div>
                                  <div class="content" style="margin-top:-10px">
                                      <i v-if="version" class="el-icon-success" style="color:#00b825;font-size:16px;"/>
                                      <i v-else class="el-icon-error" style="color:#e61717;font-size:16px;"/>
                                      Firmware {{ version?'Online':'Offline' }}
                                  </div>
                              </div>
                              <div class="uuid block">
                                <span class="title">UUID</span>
                                  <div class="content">
                                      {{ isBox ? shorter(device_information.uuid) : device_information.uuid}}
                                      <i class="el-icon-document-copy" @click.stop="copy(device_information.uuid)" />
                                      <i v-if="newBox" class="el-icon-cpu" @click.stop="copy('1HomeBox_' + device_information.uuid)" />
                                  </div>
                              </div>
                              <div class="type block">
                                  <span class="title">TYPE</span>
                                  <div class="content">
                                      {{ device_information.device_type }}
                                  </div>
                              </div>
                              <div class="ip-address block">
                                  <span class="title">LOCAL IP</span>
                                  <div class="content">
                                      {{ device_information.ip_address }}
                                  </div>
                              </div>
                              <div class="external-ip block">
                                  <span class="title">EXTERNAL IP <span v-if="device_information.external_ip === '89.212.162.174'" class="version-variant office">Office</span></span>
                                  <div class="content">
                                      
                                      {{ device_information.external_ip ? device_information.external_ip : '/' }} 
                                      <a v-if="device_information.external_ip" target="_blank" :href="'https://ipinfo.io/'+device_information.external_ip"><i style="color:black" class="el-icon-link" /></a>
                                  </div>
                              </div>
                              <div class="created-at block">
                                  <span class="title">CREATED AT</span>
                                  <div class="content" v-show="device_information.created_at">
                                      {{ printDate(device_information.created_at) }}
                                  </div>
                              </div>
                               
                              <div class="last-seen block">
                                  <span class="title">LAST SEEN</span>
                                  <div class="content" v-if="device_information.last_seen">
                                      {{ printDate(device_information.last_seen)  }} <span >({{timeSince(device_information.last_seen)}} ago)</span>
                                  </div>
                              </div>

                              <div class="release block">
                                  <span class="title">1HOME-HW VERSION <span v-if="version" class="version-variant" :class="{latest:isLatestFirmware}">{{ isLatestFirmware ? 'Latest' : 'Older' }}</span></span>
                                  <div class="content">
                                      {{ version }} 
                                  </div>
                              </div>
                              <div class="release block">
                                  <span class="title">1HOME-HW RELEASE DATE</span>
                                  <div class="content">
                                      {{ getVersionDate }}
                                  </div>
                              </div>
                              <div class="release block">
                                  <span class="title">Update scheduled (strategy: {{device_information.updateStrategy != undefined ? device_information.updateStrategy : 'none'}})</span>
                                  <div class="content">
                                      {{ device_information.updateScheduled ? new Date(device_information.updateScheduled).toUTCString() : '' }}
                                  </div>
                              </div>
                              <div class="config-tunnel-code block">
                                  <span class="title">CONFIG TUNNEL CODE</span>
                                  <div class="content">
                                      {{ device_information.configTunnelCode ? device_information.configTunnelCode : '/' }}
                                  </div>
                              </div>
                              <span class="tags" style="font-weight: bold">Tags:</span>
                              <div class="tags">
                                    <!--<div v-for='(tag, index) in tags'
                                    :key="tag"
                                    class="tag-input__tag"
                                    >
                                        {{ tag }}
                                        <span @click="removeTag(index)">x</span>
                                    </div>-->
                                    
                                  <el-tag 
                                    v-for="(tag, index) in tags"
                                    :key="tag"
                                    closable
                                    effect="dark"
                                    @close="removeTag(index)"
                                    :disable-transitions="false"
                                    class="tag">
                                    {{ tag }}
                                  </el-tag>
                                  <el-input
                                    class="input-new-tag"
                                    v-if="tagInputVisible"
                                    v-model="tagInputValue"
                                    ref="saveTagInput"
                                    size="mini"
                                    @keyup.enter.native="handleInputConfirm"
                                    @blur="handleInputConfirm"
                                  ></el-input>
                                  <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
                              </div>
                                
                              <div class="text-box">
                                <span style="font-weight: bold">Notes:</span>
                                <el-form>
                                    <el-form-item>
                                        <el-input type="textarea" class="text-box__input" v-model="notes" placeholder="Add a note"></el-input>
                                    </el-form-item>
                                </el-form>
                                <el-button type="primary" round @click="updateNotes">Save notes</el-button>
                              </div>
                            </div>
                          </el-tab-pane>
                          <el-tab-pane label="Device OS">
                            <div class="info-display">
                              <div class="change-release block">
                                  <span class="title">CHANGE RELEASE</span>
                                  <div class="content">
                                      <div id="change-release-list" v-if="appReleases.success">
                                          <template>
                                              <el-select v-if="isBox" v-model="selectedRelease" size="small" id="select-release" :class="device_information.migratable === false ? 'not-migratable': 'migratable'">
                                                  <el-option
                                                      v-for="release in appReleases.message"
                                                      :key="release.id"
                                                      :value="release.commit"
                                                      :label="release.commit + ' : ' + printDate(release.created_at, false)"
                                                      class="option-release">
                                                  </el-option>
                                              </el-select>
                                              <el-select v-if="!isBox && versionsByReleases" v-model="selectedBridgeRelease" size="small" id="select-release">
                                                  <el-option
                                                      v-for="(versions, release) in versionsByReleases"
                                                      :key="release"
                                                      :value="release"
                                                      :label="release"
                                                      class="option-release">
                                                  </el-option>
                                              </el-select>
                                              <el-select v-if="!isBox && versionsByReleases && selectedBridgeRelease.length > 0" v-model="selectedBridgeVersion" size="small" id="select-release">
                                                  <el-option
                                                      v-for="version in versionsByReleases[selectedBridgeRelease]"
                                                      :key="version"
                                                      :value="version"
                                                      :label="version"
                                                      class="option-release">
                                                  </el-option>
                                              </el-select>
                                              <el-button v-if="isBox" size="small" @click="changeRelease(selectedRelease)">Go</el-button>
                                              <el-button v-if="!isBox && selectedBridgeRelease.length > 0 && selectedBridgeVersion.length > 0" size="small" @click="changeRelease(`${selectedBridgeRelease}/${selectedBridgeVersion}`)">Go</el-button>
                                          </template>
                                      </div>
                                  </div>
                              </div>
                              <div class="track-release block">
                                  <span class="title">TRACK RELEASE</span>
                                  <div class="content">
                                      <div v-if="lockOverrideStatus.message !== ''">
                                          <i v-if="lockOverrideStatus.message" class="el-icon-success" style="color:#00b825;font-size:16px;"/>
                                          <i v-else class="el-icon-error" style="color:#e61717;font-size:16px;"/>
                                          <span v-if="!lockOverrideStatus.message">Locked to {{ shorter(device_information.release) }}</span>
                                          <el-button v-if="lockOverrideStatus.message" @click="lockToCurrentRelease()" size="mini" style="margin-left:5px" :loading='lockOverrideLoading'>Lock</el-button>
                                          <el-button v-else @click="trackRelease()" size="mini" style="margin-left:5px" :loading='lockOverrideLoading'>Track</el-button>
                                      </div>
                                      <div v-if="!isBox">
                                          <i v-if="device_information.release === 'Latest'" class="el-icon-success" style="color:#00b825;font-size:16px;"/>
                                          <i v-else class="el-icon-error" style="color:#e61717;font-size:16px;"/>
                                          <el-button v-if="device_information.release !== 'Latest'" @click="trackRelease()" size="mini" style="margin-left:5px">Track</el-button>
                                      </div>
                                  </div>
                              </div>
                            </div>
                          </el-tab-pane>
                          <el-tab-pane v-if="isBox" label="Services" name="services" class="services-tab">
                            <div class="services">
                                <div v-for="(service, serviceName) in this.device_information.services" v-bind:key="service.key" class="services-output">
                                    <div v-for="(service1) in service" v-bind:key="service1.key" class="services-output-list">
                                        <div class="services-output-list-div1">
                                            <span class="name">[{{ serviceName }}]</span> <span class="status" :class="service1.status === 'Dead' ? 'red' : 'green'">({{ service1.status }})</span>
                                            <span class="commit">: {{ service1.commit }}</span>
                                            <span id="services-output-list-div1-download_progress" v-if="service1.download_progress">{{ service1.download_progress }}%</span>
                                        </div>
                                        <div class="services-output-list-button">
                                            <el-button @click="manageService(service1.image_id, 'START')" title="start service"><i class="el-icon-video-play" /></el-button>
                                            <el-button @click="manageService(service1.image_id, 'STOP')" title="stop service"><i class="el-icon-video-pause" /></el-button>
                                            <el-button @click="manageService(service1.image_id, 'RESTART')" title="restart service"><i class="el-icon-refresh-right" /></el-button>
                                        </div>

                                        <!-- <button @click="manageService(service1.image_id, 'STOP')">Stop</button> -->
                                        <!-- <button @click="manageService(service1.image_id, 'RESTART')">Restart</button> -->
                                    </div>
                                </div>
                            </div>
                          </el-tab-pane>
                          <el-tab-pane v-if="logLevel" label="Options" name="options" class="services-tab">
                              <div class="device-options">
                                  <div class="device-options-body">
                                      <span>Log Level:</span>
                                      <el-select v-model="logLevel" @change="logLevelChanged" size="small">
                                          <el-option value="trace" label="trace"></el-option>
                                          <el-option value="debug" label="debug"></el-option>
                                          <el-option value="info" label="info"></el-option>
                                          <el-option value="warn" label="warn"></el-option>
                                          <el-option value="error" label="error"></el-option>
                                          <el-option value="fatal" label="fatal"></el-option>
                                      </el-select>
                                  </div>
                              </div>
                          </el-tab-pane>
                          <el-tab-pane v-if="flags" label="Flags" name="flags">
                              <div class="flags">
                                  <div v-for="(value, flag) in this.flags" v-bind:key="flag.key" class="flag">
                                      <span>{{flag}}</span>
                                      <el-switch
                                          v-if="typeof value === 'boolean'"
                                          v-model="flags[flag]"
                                          @change="featureFlagChanged"
                                          class="switch">
                                      </el-switch>
                                      <input
                                          v-if="typeof value === 'string'"
                                          v-model="flags[flag]"
                                          @change="featureFlagChanged"
                                          class="input" />
                                  </div>
                              </div>
                          </el-tab-pane>
                          <el-tab-pane :disabled="!isBox" label="Terminal">
                            <div  class="device-ssh panel">
                              <div class="header">
                                  <h2 class="title">Terminal</h2>
                                  <el-button v-if="socketConnected" @click="blinkDeviceLight" size="small" icon="el-icon-sunrise-1" title="Blink device internal light"></el-button>
                                  <el-button v-if="socketConnected" @click="goToDataDir" size="small" icon="el-icon-folder-opened" title="Go to data directory"></el-button>
                                  <el-button v-if="socketConnected" @click="startDockerContainer" size="small" icon="el-icon-upload2" title="Exec docker container"></el-button>
                                  <el-button v-if="socketConnected" @click="cpuInfo" size="small" icon="el-icon-info" title="Display cpu info"></el-button>
                                  <el-button v-if="socketConnected" @click="stopSshConnection" size="small" class="action-button">Disconnect</el-button>
                              </div>
                              <div class="terminal-display">
                                  <div id="terminal"></div>
                                  <div v-show="!socketConnected" class="overlay">
                                      <el-button v-if="device_information.status === 'Online'" class="start-ssh action-button" @click="socketConnect">Connect to device</el-button>
                                      <p v-else>Device offline</p>
                                  </div>
                              </div>
                          </div>
                          </el-tab-pane>
                        </el-tabs>
                        
                       
                       
                        
                        
                       
                        <!--<div class="release block">
                            <span class="title">RELEASE</span>
                            <div class="content">
                                {{ device_information.release ? (device_information.release.includes('/') ? device_information.release : shorter(device_information.release)) : shorter(device_information.release) }}
                                <i class="el-icon-document-copy" @click.stop="copy(device_information.release)" />
                            </div>
                        </div>
                        <div class="host-os block">
                            <span class="title">HOST OS</span>
                            <div class="content">
                                {{ device_information.os_version }} - <span class="os-variant">{{ device_information.os_variant }}</span>
                            </div>
                        </div>-->
                        
                                       
                        
                    </div>
                </div>
                <div class="device-logs panel">
                    <div class="header">
                        <h2 class="title">Logs</h2>
                        <el-switch
                            v-if="logSource && !isBox"
                            v-model="newLogs"
                            active-text="New Id"
                            inactive-text="Old Id"
                            @change="logsSettingsChanged">
                        </el-switch>
                        <el-switch
                            class="log-switcher"
                            v-model="logSource"
                            active-text="Elastic"
                            inactive-text="Device"
                            :disabled="!isBox">
                        </el-switch>
                        <el-button v-if="!isBox || newBox" size="small">
                            <a class="link" target="_blank" :href="logsLink">Logs</a>
                        </el-button>
                        <el-button v-if="metricsLink.length > 0" size="small">
                            <a class="link" :href="metricsLink" target="_blank">Metrics</a>
                        </el-button>

                        <!-- <a class="kibana-link link" :href="kibanaLink" target="_blank">Kibana</a> -->

                        <!-- <el-button icon="el-icon-refresh" @click="refreshLogs" size="small"></el-button> -->
                        <!-- <el-button v-if="ascendant === 1" icon="el-icon-arrow-down" @click="sortLogs(-1)" size="small"></el-button> -->
                        <!-- <el-button v-else icon="el-icon-arrow-up" @click="sortLogs(-1)" size="small"></el-button> -->
                        <!-- <el-button @click="balenaLogs" size="small">Balena Logs</el-button> -->
                    </div>
                    <div class="logs-display" id="logsContainer">
                        <div class="logs-container" v-if="logSource">
                            <div v-if="!getLogs.elastic" v-loading="!getLogs.elastic" class="loader"></div>
                            <span v-if="getLogs.elastic && getLogs.elastic.length === 0">No elasticsearch logs for this device</span>
                            <div v-for="(log, idx) in getElasticLogs" :key="idx" class="log">
                              
                                <span class="logs-dateTime">{{ log.dateTime ? printDate(log.dateTime) : '' }}</span>
                                <span class="logs-severity" :class="log.severity">[{{ log.severity }}]</span> - 
                                <span class="logs-message">{{ log.message }}</span>
                            </div>
                            <div class="log">&nbsp;</div>
                        </div>
                        <div class="logs-container" v-else>
                            <div v-if="!getLogs.device" v-loading="!getLogs.device" class="loader"></div>
                            <span v-if="getLogs.device && getLogs.device.length === 0">No elasticsearch logs for this device</span>
                            <div v-for="(log, idx) in getLogs.device" :key="idx" class="log">
                                <span class="logs-dateTime">{{ log.timestamp ? printDate(log.timestamp) : '' }}</span> - 
                                <span class="logs-message">{{ log.message }}</span>
                            </div>
                            
                            
                        </div>
                        
                    </div>
                </div>
            </div>
            <div v-if="false" class="main-row">
                
                
            </div>
		</el-main>
	</div>
</template>

<script>
    import { Terminal } from 'xterm';
    import { FitAddon } from 'xterm-addon-fit';

    import router from '../router'
    import { mapGetters, mapActions, mapMutations } from 'vuex';
    import store from '../store';
    import { copyToClipboard } from './../utils/my_module'
    import { rebootDevice, restartApp, services, deleteDevice, getAppReleases, pinToRelease, lockOverride, startStopRestartService, purgeDevice, deviceFromCloud, deviceStoreFlags, setDeviceStoreFlags, deviceLogLevel, setDeviceLogLevel, deviceVersion, forceUpdateDevice, storeCache, getDeviceTags, getDeviceNotes, addDeviceTag, removeDeviceTag, updateDeviceNotes } from './../api'
    import config from './../config/config'
    import * as axios from 'axios'
    
    export default {
        name: 'DeviceDisplay',
        data () {
            return {
                device_information: {},
	            ascendant: -1,
	            refreshInterval: null,
	            socket: null,
                socketConnected: false,
	            selectedRelease: '',
	            appReleases: {},
	            metricsLink: '',
				lockOverrideStatus: {'message': ''},
                lockOverrideLoading: false,
				isShowPopup: false,
                terminal: null,
                fitAddon: null,
                terminalInput: '',
                prevCommand: '',
                socketPingInterval: null,
                alphanumeric: /^([0-9]|[a-z])+([0-9a-z]+)$/i,
                logSource: true,
                newBox: false,
                newLogs: true,
                versionsByReleases: false,
                selectedBridgeRelease: '',
                selectedBridgeVersion: '',
                flags: false,
                logLevel: false,
                activeTab: 'services',
                version: '',
                homeKitFirmwareVersion: 'homekitversion',
                latestVersions: [],
                tags: [],
                notes: '',
                tagInputVisible: false,
                tagInputValue: '',
            }
        },
        methods: {
            ...mapMutations([
				'setLogs'
			]),
		    ...mapActions([
		    	'fetchLogsBalena',
                'fetchLogsElastic',
                'fetchDevices',
                'clearLogs',
                'createKibanaLink'
		    ]),
            navigate() {
                this.$router.replace({ name: "DevicesList" });
            },
            shorter(str) {
                if (str && str.length >= 7) return str.slice(0,7);
	            else return str;
            },
		    // async sortLogs(changeSens=1) { // sens = 1 -> Keep like it is, sens -1 -> Reverse
		    // 	var sens = this.ascendant*changeSens;
		    // 	await store.state.logs.sort(function(a,b) { return sens*(new Date(a.dateTime).getTime()-new Date(b.dateTime).getTime()) });
		    // 	this.ascendant = sens;
			// 	await this.changeColor()
		    // },
            timeSince(dateM) {
                var date = new Date(dateM)

                var seconds = Math.floor((new Date() - date) / 1000);

                var interval = seconds / 31536000;

                if (interval > 1) {
                    return Math.floor(interval) + " years";
                }
                interval = seconds / 2592000;
                if (interval > 1) {
                    return Math.floor(interval) + " months";
                }
                interval = seconds / 86400;
                if (interval > 1) {
                    return Math.floor(interval) + " days";
                }
                interval = seconds / 3600;
                if (interval > 1) {
                    return Math.floor(interval) + " hours";
                }
                interval = seconds / 60;
                if (interval > 1) {
                    return Math.floor(interval) + " minutes";
                }
                return Math.floor(seconds) + " seconds";
            },
		    refreshLogs() {
                if (this.logSource) {
                    let uuid = this.device_information.uuid
                    if (this.newBox) this.fetchLogsElastic('1HomeBox_' + uuid)  // Box -> 1HomeBox_c3317d1ca72be63e6660df0360795124
                    else if (uuid.includes('knxBridge')) {
                        if (this.newLogs) this.fetchLogsElastic(uuid)           // Bridge -> knxBridge_00-24-6d-01-d7-cc
                        else {                                                  // Bridge -> 00:24:6d:01:d7:cc
                            let rawMac = uuid.split('_')[1]
                            rawMac = rawMac.toUpperCase()
                            let splitArr = rawMac.split('-')
                            rawMac = splitArr.join(':')
                            rawMac = rawMac + '\n'
                            this.fetchLogsElastic(rawMac)
                        }                                                       // Box -> c3317d1ca72be63e6660df0360795124
                    } else {                                                    
                        this.fetchLogsElastic(uuid)
                    }
                } else {
                    this.fetchLogsBalena(this.device_information.uuid)
                }
		    },
		    copy(element) {
		    	copyToClipboard(element);
                this.$notify({
                    message: 'Copied ' + element,
                    type: 'success',
                    position: 'bottom_left'
                });
		    },
		    async balenaLogs() {
		    	this.$router.push({name: 'BalenaLogs', params: {"deviceID": this.device_information.uuid}});
		    },
		    async forceUpdate() {
		    	if (confirm("Do you want to force update ?")) {
			    	this.disableButtons();
                    let uuid = this.device_information.uuid;
                    if (this.isBox) {
                        uuid = '1HomeBox_' + uuid;
                    }
			    	let reboot = await forceUpdateDevice(uuid);
			    	if (reboot.success) {
                        if (this.isBox) this.$message.info("Device force updated");
                        else this.$message.info("Force update device request sent")
                    }
			    	else this.$message.error(reboot.message);
			    	this.disableButtons();
			    }
		    },
            async cacheStore(){
                await storeCache({code: this.device_information.configTunnelCode, server: this.device_information.server})
            },
            async reboot() {
		    	if (confirm("Do you want to reboot this device ?")) {
			    	this.disableButtons();
                    
                    
			    	let reboot = await rebootDevice(this.device_information.uuid);
			    	if (reboot.success) {
                        if (this.isBox) this.$message.info("Device rebooted");
                        else this.$message.info("Reboot device request sent")
                    }
			    	else this.$message.error(reboot.message);
			    	this.disableButtons();
			    }
		    },
		    async restart() {
		    	if (confirm("Do you want to restart the app?")) {
			    	this.disableButtons();
			    	let restart = await restartApp(this.device_information.uuid, this.isBox ? this.device_information.appId : -1);
			    	if (restart.success) {
                        if (this.isBox) this.$message.info("Device restarted");
                        else this.$message.info("Restart device request sent")
                    }
			    	else this.$message.error(restart.message);
			    	this.disableButtons();
			    }
		    },
			disableButtons() {
				let buttons = document.getElementsByClassName("button-reboot-restart")
				for (let i = 0; i < buttons.length; i++) {
					buttons[i].disabled = !buttons[i].disabled
				}
			},
			async deleteDevice1() {
		    	if (confirm("Do you really want to delete this device ?")) {
		    		let res = await deleteDevice(this.device_information.uuid);
					if(res.success) { this.$message.info(res.message); this.navigate();}
			  		else this.$message.error(res.message);
		    	}
			},
			async refreshServices() {
				let serv = await services(this.device_information.uuid);
			    if (serv.success) {
                    this.device_information = {
                        ...this.device_information,
                        ...serv.message
                    }
                }
			},
			async refreshData() {
			    if (this.device_information.uuid != undefined) await this.refreshLogs();
                if (this.isBox) {
			        await this.refreshServices();
			        if (this.device_information.uuid != undefined) await this.changelockOverride("STATUS");
                } else {
                    this.fetchDevices({mode: 'bridge', searchValue: ''})
                        .then(() => {
                            let devices = this.getDevices.all.filter(d => d.uuid === this.$route.params.uuid);
                            if (devices.length === 0) {
                                this.$notify({
                                    message: 'Couldn\'t find this device in store!',
                                    type: 'error',
                                    position: 'bottom-right'
                                });
                                return;
                            } else {
                                this.device_information = {
                                    ...this.device_information,
                                    ...devices[0]
                                }
                            }
                        })
                }
                this.lockOverrideLoading = false;
			},
			stopSshConnection() {
				this.socket_sendMessage("end");
                this.terminal.clear();
				this.socket.close();
                clearInterval(this.socketPingInterval);
				setTimeout(()=>{this.$forceUpdate()},500);
			},
            socketConnect() {
                if (window.hasOwnProperty("WebSocket")) { // webkit-browser
                    this.socket = new WebSocket(config.wsServer);
                } else if (window.hasOwnProperty("MozWebSocket")) { // firefox 
                    this.socket = new MozWebSocket(config.wsServer);
                } else {
                    alert("Your browser doesn't support WebSocket.");
                    return;
                }
                this.socket.onopen = () => {
                    this.socketConnected = true;
                    this.socket.send("[*!:]" + this.device_information.uuid);
                    this.socketPingInterval = setInterval(() => {
                        this.socket.send('PING');
                    }, 30000)
                };
            
                this.socket.onmessage = (msg) => {
                    if (msg.data === 'PONG') return;
                    console.log("msg data : ", msg.data)
                    msg = JSON.parse(msg.data);
                    this.setTerminalOutput(msg);
                };
            
                this.socket.onclose = () => {
                    console.log('onclose');
                    this.socketConnected = false;
                    clearInterval(this.socketPingInterval);
                };
                this.socket.onerror = (error) => {
                    console.log('onerror', error);
                    this.socketConnected = false;
                }
            },
            socket_sendMessage(msg) {
                if (this.socket.readyState === this.socket.OPEN) this.socket.send(msg);
                else this.socketConnected = false;
            },
			async sendSSHCommandV2() {
		    	// console.log("Sending ssh command")
		    	// let command = document.getElementById('coucou').value;
		    	// let uuid = this.device_information.uuid;
		    	// this.getCurrentWorkingDirectory()
		    	// this.socket.sendMessage(command);
		    },
		    async changeRelease(release) {
			    if (!(release instanceof Object)) {
		    		let res = await pinToRelease(this.device_information.uuid, release);
		    		if (res.success) this.$message.info("Release changed successfully");
		    		else this.$message.error(res.message);
			    }
		    },
		    async changelockOverride(action) {
		    	let res = await lockOverride(this.device_information.uuid, action);
                if (res.success && action === 'STATUS') this.lockOverrideStatus = res;
		    	if (!res.success) this.$message.error(res.message);
		    },
            async lockToCurrentRelease() {
                this.lockOverrideLoading = true;
                let res = await pinToRelease(this.device_information.uuid, this.device_information.release);
                if (res.success) this.refreshData();
                else this.$message.error(res.message);
            },
            async trackRelease() {
                this.lockOverrideLoading = true;
                let res = await lockOverride(this.device_information.uuid, 'DISABLE');
		    	if (res.success) this.refreshData();
		    	else this.$message.error(res.message);
            },
		    async manageService(imageId, action) {
		    	// console.log("ID ", imageId);
		    	let res = await startStopRestartService(this.device_information.uuid, imageId, action);
		    	if(res.success) this.$message.info(action + ' : ' + res.message);
		    	else this.$message.error(res.message);
		    },
		    async purge() {
		    	if (confirm("/!\\ Do you want to purge this device ? /!\\\nAll datas will be lost")) {
			    	let res = await purgeDevice(this.device_information.uuid);
			    	if(res.success) this.$message.info("Purge" + ' : ' + res.message);
			    	else this.$message.error(res.message);
			    }
		    },
            printDate(dateStr, time = true) {
                //if (!dateStr || (typeof dateStr === 'string' && dateStr.split('-').length < 3)) return dateStr;
                let date = new Date(dateStr);
                return `${date.getDate()}.${date.getMonth()+1}.${date.getFullYear()}` + (time ? ` - ${this.leadingZero(date.getHours())}:${this.leadingZero(date.getMinutes())}:${this.leadingZero(date.getSeconds())}` : '');
            },
            leadingZero(num) {
                var s = num+"";
                while (s.length < 2) s = "0" + s;
                return s;
            },
            setTerminalOutput(output) {
                    this.terminal.write(output.out);
            },
            goToDataDir() {
                this.socket_sendMessage("cd /mnt/data/docker/volumes/$(ls /mnt/data/docker/volumes/ | grep resin-data)/_data\n");
            },
            blinkDeviceLight() {
                this.socket_sendMessage("curl -k https://releases.1home.io/files-misc/rpi/ledtest.sh | bash -E\n")
            },
            startDockerContainer() {
                this.socket_sendMessage("balena exec -ti $(balena ps | grep -i main | cut -d ' ' -f 1) bash\n");
            },
            cpuInfo() {
                this.socket_sendMessage("cat /proc/cpuinfo\n");
            },
            logsSettingsChanged() {
                this.refreshLogs()
            },
            async featureFlagChanged() {
                let res = await setDeviceStoreFlags({code: this.device_information.configTunnelCode, flags: this.flags, server: this.device_information.server})
                if (res && res.data && res.data.success) {
                    this.$notify({
                        message: 'Device feature flags set successfully',
                        type: 'success',
                        position: 'bottom-right'
                    });
                }
            },
            async logLevelChanged() {
                let res = await setDeviceLogLevel({code: this.device_information.configTunnelCode, server: this.device_information.server, level: this.logLevel})
                if (res && res.data && res.data.success) {
                    this.$notify({
                        message: 'Log level set successfully',
                        type: 'success',
                        position: 'bottom-right'
                    });
                }
            },
            handleClick(tab) {
              if (tab.paneName == '5') {
                setTimeout(()=>{
                  if (!this.terminal) {
                    console.log('Terminal init')
                   // Init Terminal
                   this.terminal = new Terminal();
                   this.fitAddon = new FitAddon();
                   this.terminal.loadAddon(this.fitAddon);
                   this.terminal.open(document.getElementById('terminal'));
                   this.fitAddon.fit();
                   this.terminal.onData(data => {
                     console.log('terminal got data: ', data);
                     this.socket_sendMessage(data);
                   });

                  }
  
                }, 1000)
    
              } else {
                /*if (this.terminal) {
                  this.terminal.dispose()
                  this.terminal = null
                }*/
              }
            },
            
            showInput() {
                this.tagInputVisible = true;
                this.$nextTick(_ => {
                    this.$refs.saveTagInput.$refs.input.focus();
                });
            },

            async handleInputConfirm() {
                let tagInputValue = this.tagInputValue;
                if (tagInputValue) {
                    let res = await addDeviceTag(this.device_information.uuid, tagInputValue);
                        if (res.success) {
                            this.tags.push(tagInputValue);
                            this.$message({
                                message: `Tag "${tagInputValue}" added.`, 
                                type: 'success',
                            });
                        } else {
                            this.$message({
                                message: 'There was something wrong with adding a tag.', 
                                type: 'error',
                            });
                        }
                }
                this.tagInputVisible = false;
                this.tagInputValue = '';
            },
            
            async removeTag (index) {
                let tag = this.tags[index];
                let res = await removeDeviceTag(this.device_information.uuid, tag);
                if (res.success) {
                    this.tags.splice(index, 1);
                    this.$message({
                        message: `Tag "${tag}" deleted.`, 
                        type: 'success',
                    });
                } else {
                    this.$message({
                        message: 'There was something wrong with removing the tag.', 
                        type: 'error',
                    });
                }
            },

            async updateNotes() {
                let res = await updateDeviceNotes(this.device_information.uuid, this.notes);
                if (res.success) {
                    this.$message({
                        message: 'Notes saved.', 
                        type: 'success',
                    });
                } else {
                    this.$message({
                        message: 'There was something wrong with saving notes.\nError: res.', 
                        type: 'error',
                    });
                }
            }
        },
		computed: {
			...mapGetters([
				'getLogs',
				'getTerminalOutput',
                'getDevices'
			]),
      getElasticLogs() {
        if (!this.getLogs.elastic) {
          return [];
        } 
        return this.getLogs.elastic.filter(a=>new Date(a.dateTime).getTime() < ((Date.now()) + 2*(24*60*60*1000)))
      },
            isLatestFirmware(){
                if (this.device_information.softwareBranch) {
                    let latestVersion = this.latestVersions.find(a=>a.appName == this.device_information.softwareBranch)
                    if (latestVersion) {
                        return this.version === latestVersion.firmwareVersion
                    }
                }
                return false
            },
            isBox() {
                return !this.$route.params.uuid.includes('weinzierl') && !this.$route.params.uuid.includes('knxBridge')
            },
            logsLink() {
                if (this.isBox && !this.newBox) {
                    return `https://kibana.1home.io/app/kibana#/discover?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-15m,to:now))&_a=(columns:!(severity,message),filters:!(),index:logs_index,interval:auto,query:(language:kuery,query:'fields.deviceID%20:%20%22${this.device_information.uuid}%22'),sort:!(dateTime,desc))`
                    //return `https://kibana.1home.io/app/kibana#/discover?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-15m,to:now))&_a=(columns:!(severity,message),filters:!(),index:logs_index,interval:auto,query:(language:kuery,query:'fields.deviceID%20:%20%22${this.device_information.uuid}%22'),sort:!(dateTime,desc))`
                } else {
                    return `https://kibana.1home.io/app/kibana#/discover?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-15m,to:now))&_a=(columns:!(appName,json.level,json.message,message,json.error),filters:!(),index:weinzierl,interval:auto,query:(language:kuery,query:'deviceID%20:%20%22${this.newBox ? '1HomeBox_' + this.device_information.uuid : this.device_information.uuid}%22'),sort:!(dateTime,desc))`
                    //return `https://kibana.1home.io/app/kibana#/discover?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-1h,to:now))&_a=(columns:!(json.level,json.message,message),index:weinzierl,interval:auto,query:(language:kuery,query:'deviceID%20:%20%22${this.newBox ? '1HomeBox_' + this.device_information.uuid : this.device_information.uuid}%22'),sort:!(dateTime,desc))`
                }
            },
            getVersionDate(){
                try{
                    if (this.version) {
                        let versionDate = this.version.split('.')[1];
                        let year = versionDate.substring(0,4)
                        let month = versionDate.substring(4,6)
                        let day = versionDate.substring(6,8)
                        return day+'-'+month+'-'+year
                    
                    }
                } catch (err) {
                    return 'unknown'
                }
            }
		},
    
        async mounted() {
            let mode;
            if (this.isBox) mode = 'box';
            else mode = 'bridge';
            await this.fetchDevices({mode: mode, searchValue: ''})
            let devices = this.getDevices.all.filter(d => d.uuid === this.$route.params.uuid);
            if (devices.length === 0) {
                this.$notify({
                    message: 'Couldn\'t find this device in store!',
                    type: 'error',
                    position: 'bottom-right'
                });
                return;
            } else {
                this.device_information = devices[0];
            }

            try{
                let res = await axios.get('/api/releases')
                this.latestVersions = res.data.latest
            } catch(err){
                console.error(err);
            }

            // Check if new box and get data from cloud
            let res = await deviceFromCloud(this.device_information.uuid);
            if (res.data.data.length > 0) {
                let cloudDevice = res.data.data[0];

                let server = '1ho.me'
                if (cloudDevice.server == 'tunnel1.1home.io') {
                  server = cloudDevice.server;
                }

                this.device_information = {
                    ...this.device_information,
                    external_ip: cloudDevice.ip,
                    configTunnelCode: cloudDevice.configTunnelCode,
                    updateScheduled: cloudDevice.updateScheduled,
                    updateStrategy: cloudDevice.updateStrategy,
                    migratable: cloudDevice.migratable,
                    softwareBranch: cloudDevice.softwareBranch,
                    server: cloudDevice.server,
                    isPurchased: !!cloudDevice.isPurchased,
                }
                if (this.isBox) this.newBox = true;

                
                this.metricsLink = `https://grafana.cloud.1home.io/d/Np8mmX7Gk/1home-hw-device?orgId=1&var-datasource=Prometheus&var-job=1home-device&var-instance=${res.data.data[0].configTunnelCode}.${server}:80`

                // Fetch device store flags
                let flags = await deviceStoreFlags({code: cloudDevice.configTunnelCode, server: cloudDevice.server})
                if (flags.data.data && typeof flags.data.data === 'object') this.flags = flags.data.data

                // Fetch logs level
                let logLvl = await deviceLogLevel({code: cloudDevice.configTunnelCode, server: cloudDevice.server})
                if (logLvl.data.data && logLvl.data.data.logLevel) this.logLevel = logLvl.data.data.logLevel

                //Fetch device version
                let version = await deviceVersion({code: cloudDevice.configTunnelCode, server: cloudDevice.server})
                if (version.data.data && version.data.data.version) {
                    this.version = version.data.data.version;
                    this.homeKitFirmwareVersion = version.data.data.homeKitFirmwareVersion
                }
                console.log(version)
            }

            this.refreshData();
            this.refreshInterval = setInterval(() => {
                this.refreshData();
            }, 5000)

            this.appReleases = await getAppReleases(this.device_information.appId);
            if (!this.isBox) {
                let newReleases = {};
                this.appReleases.message.map(r => {
                    let spl = r.commit.split('/')
                    if (newReleases[spl[0]]) newReleases[spl[0]].push(spl[1])
                    else newReleases[spl[0]] = [spl[1]]
                })
                this.versionsByReleases = newReleases;
            }

            this.tags = await getDeviceTags(this.device_information.uuid);
            this.notes = await getDeviceNotes(this.device_information.uuid);
            // this.terminal.onKey(e => {
            //     let keyCode = e.domEvent.keyCode;
            //     if (keyCode === 8) {     // Backspace
            //         // this.terminal.write("\b \b");
            //     }
            // });

           
        },
        watch: {
          'getElasticLogs': function(newData, oldData) {
            
            if (oldData.length == 0) {
              setTimeout(()=>{
                document.getElementById('logsContainer').scrollTop = 9999999999999999999
              },1000)
            }
          }
        },
		beforeDestroy() {
			if (this.socketConnected) this.stopSshConnection();
            clearInterval(this.refreshInterval);
            this.clearLogs();
		}
    }
</script>

<style>
    .el-alert__title{
        font-size:19px;
        font-weight: 700;
    }
    .not-migratable #select-release{
        background-color: #F56C6C;
        color:black;
    }
    .not-migratable #select-release::placeholder{
        color:white;
    }
    .info-tabs > .el-tabs__content {
      height: calc(100% - 35px);
    }
    .info-tabs  .el-tab-pane{
      height: 100%;
    }
</style>

<style scoped>

.right-buttons{
    margin-left:auto;
}
.el-alert__title{
        font-size:19px;
    }
    .main-row {
        flex: 0 0 100%;
        height: 100%;
        display: flex;
    }
    .main-row .panel {
        display: flex;
        flex-direction: column;
        flex: 1 1;
        height: 100%;
        border: 1px solid #34495e;
    }

    .el-icon-document-copy,
    .el-icon-cpu {
        cursor: pointer;
    }

    .kibana-link {
        color: white;
        padding: 8px 12px;
        font-size: 12px;
        background-color: #f04e98;
        border-radius: 3px;
        margin-left: 15px;
    }

    #change-release-list {
        display: flex;
    }

    .el-header {
		display: flex;
		align-items: center;
		background-color: #34495e;
	}
    .el-header .action-button.force-update {
    }
    .el-header .action-button.cache-store {
        margin-left: auto;
        
    }
	.el-main {
		overflow: hidden;
        display: flex;
        height: calc(100vh - 60px);
        flex-wrap: wrap;
        padding: 0;
	}
    .header {
        display: flex;
        align-items: center;
        padding: 15px;
        min-height: 32px;
    }

    .device-service-tabs{
      overflow: auto;
      position: absolute;
      top: 0px;
      bottom: 20px;
      left: 0px;
      right: 0px;
    }

    .device-info .header,
    .device-services .header {
        border-bottom: 1px solid lightgrey;
    }
    .info-display {
        height: 100%;
        display: flex;
        justify-content: space-;
        align-items: start;
        flex-wrap: wrap;
    }
    .info-display .block {
        flex: 0 0 33.3%;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
    }
    .info-display .block .title {
        font-weight: bold;
        font-size: 14px;
        padding-left: 10px;
    }
    .info-display .block .content {
        padding: 5px 10px 10px;
        font-size: 14px;
    }
    .info-display .block.host-os .os-variant {
        background: green;
        color: white;
        padding: 0 5px;
        border-radius: 10px;
        font-size: 12px;
    }

    .version-variant {
        color: white;
        padding: 2px 5px;
        border-radius: 10px;
        font-size: 12px;
        background-color: #F56C6C;
    }
    .version-variant.latest {
        background-color: mediumseagreen;
    }
    .version-variant.office {
        background-color: #3a8ee6;
    }


	/* Logs */
	.logs-header {
		display: table;/*
		border: 1px solid #F5FFFA;*/
		height: 10%;
		width: 100%;
	}
	.logs-header #logs-title {
		display: table-cell;
	    vertical-align: middle;
	    text-align: left;
	    padding-left: 3%;
	    background: white;
	}
	#logs-title {
		width: 25%;
	}

	.logs-dateTime {
		color: lightsteelblue/*whitesmoke/*rgb(90,200,191)*/;
	}

	/* Terminal */
	.terminal-header {
		display: table;/*
		border: 2px solid #F5FFFA;*/
		height: 10%;
		width: 100%;
	}
	.terminal-header #terminal-title {
		display: table-cell;
	    vertical-align: middle;
	    text-align: left;
	    padding-left: 3%;
	    background: white;
	}
	#terminal-title {
		width: 25%;
	}
	#terminal-input-form1 {
		float: left;
	}/*
	#terminal-input-form2 {
		float: right;
	}*/
	
	#terminal-user-uuid {
		color: rgb(138,219,46);
	}
	#terminal-directory {
		color: rgb(111,145,170);
	}
	button {
		cursor: pointer;
	}
	button:disabled {
		cursor: not-allowed;
	}
	/* Services */
	.services-header {
		display: table;/*
		border: 2px solid #F5FFFA;*/
		height: 10%;
		width: 100%;
		background-color: white;
	}
	.services-output {
		width: 100%;
		height: 100%;
	}
	.services-output-list {
		padding: 10px 10px 0;
		display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
	}
    .services-output-list .name {
        color: royalblue;
        font-weight: bold;
    }
    .services-output-list .status {
        font-weight: bold;
    }
    .services-output-list .status.red {
        color: firebrick;
    }
    .services-output-list .status.green {
        color: green;
    }
    .services-output-list .commit {
        font-size: 14px;
    }
	.services-output-list-button button {
		padding: 2px 2px;
	}
	
    .header .title {
        font-size: 1.2rem;
        margin: 0 auto 0 0;
    }
    .header .link {
        text-decoration: none;
    }
    .logs-display {
        flex: 1 1 0;
		background: black;
		color: silver;
		text-align: left;
		overflow: auto;
        padding: 10px;
        position: relative;
    }
    .logs-display .logs-container {
        width: 100%;
        height: 100%;
    }
    .logs-display .log {
        padding: 1px 0;
        font-size: 14px;
    }
    .logs-display .loader {
        width: calc(100% + 20px);
        height: calc(100% + 20px);
        margin: -10px;
    }
    .logs-dateTime {
        color: #6b6b6b;
    }
    .logs-severity.info {
        color: #7dba44;
    }
    .logs-severity.warn {
        color: #E6A23C;
    }
    .logs-severity.error {
        color: #fd5252;
    }
    .logs-severity.debug {
        color: #5e93d6;
    }
    .logs-message {
        word-break: break-word;
    }
    .log-switcher {
        margin: 0 20px;
    }
    .terminal-display {
		flex: 1 1 0;
		background: black;
		color: white;
		text-align: left;
        overflow: auto;
        position: relative;
	}
    .terminal-display .overlay {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: black;
        z-index: 1000;
    }

    #terminal {
        width: 100%;
        height: 100%;
    }

	#remote-ssh:hover, .balena-cmd:hover {
		cursor: pointer;
		color: #202020;
	}

    .device-services.panel {
        padding: 10px;
        flex: 0 0 calc(50% - 22px);
        position: relative;

    }

    .flags {
    }

    .flags .flag {
        display: flex;
        margin: 5px;
        padding: 5px;
    }

    .flags .flag .switch,
    .flags .flag .input {
        margin-left: 20px;
    }

    .device-options {
    }

    .device-options-body {
        display: flex;
        padding: 10px;
        align-items: center;
    }

    .text-box {
        width: 100%;
        height: 100px;
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: 5px;
        text-align: left;
        border-radius: 5px;
    }

    .text-box__input {
        width: 100%;
        height: 100%;
    }

    .tag {
        font-weight: bold;
    }
    .tags {
        width: 100%;
        text-align: left;
        margin-left: 10px;
        margin-right: 10px;
    }

    .el-tag + .el-tag {
        margin-left: 5px;
    }
    .button-new-tag {
        margin-left: 5px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }
    .input-new-tag {
        width: 90px;
        margin-left: 5px;
        vertical-align: bottom;
    }
</style>


// WEBPACK FOOTER //
// src/components/Device.vue